import axios from "axios";

const getDefaultState = () => {
  return {
    municipios: [],
    municSelec: 0,
    municLoading: true,
    localidades: [],
    localidSelec: 0,
    localidLoading: true,
    estados: [],
    estadoSelec: "",
    estadoLoading: true,
  };
};

const locaisStore = {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
    setEstados(state, ufs) {
      state.estados = ufs;
    },
    setMunicipios(state, municipios) {
      state.municipios = municipios;
    },
    setLocalidades(state, localidades) {
      state.localidades = localidades;
    },
    setEstadoSelec(state, uf) {
      state.estadoSelec = uf;
    },
    setMunicSelec(state, value) {
      state.municSelec = value;
    },
    setLocalidSelec(state, value) {
      state.localidSelec = value;
    },
    setLoadingEstado(state, value) {
      state.estadoLoading = value;
    },
    setLoadingMunic(state, value) {
      state.municLoading = value;
    },
    setLoadingLocalid(state, value) {
      state.localidLoading = value;
    },
  },
  actions: {
    async getEstados(context) {
      context.commit("setLoadingEstado", true);
      context.commit("setEstados", []);
      await axios
        .get("/nutricao-animal/locais/estados")
        .then((res) => {
          if (res.data.success) {
            context.commit("setEstados", res.data.data);
          }
        })
        .finally(() => {
          context.commit("setLoadingEstado", false);
        });
    },
    async getMunicipios(context) {
      context.commit("setLoadingMunic", true);
      context.commit("setMunicipios", []);
      await axios
        .get("/nutricao-animal/locais/municipios", {
          params: {
            uf: context.state.estadoSelec,
          },
        })
        .then((res) => {
          if (res.data.success) {
            context.commit("setMunicipios", res.data.data);
          }
        })
        .finally(() => {
          context.commit("setLoadingMunic", false);
        });
    },
    async getLocalidades(context) {
      context.commit("setLoadingLocalid", true);
      context.commit("setLocalidades", []);
      await axios
        .get("/nutricao-animal/locais/localidades", {
          params: {
            codmunicipio: context.state.municSelec,
          },
        })
        .then((res) => {
          if (res.data.success) {
            context.commit("setLocalidades", res.data.data);
          }
        })
        .finally(() => {
          context.commit("setLoadingLocalid", false);
        });
    },
  },
  getters: {
    getLocalidadeSelecionada(state) {
      return state.localidades.find((loc) => loc.codigo == state.localidSelec);
    },
  },
};

export default locaisStore;
